import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Header.css";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      closeMenu();
    }
  };

  const handleLogoClick = () => {
    scrollToSection("hero");
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <div className="logo">
          <motion.h1 onClick={handleLogoClick} style={{ cursor: "pointer" }} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95, rotate: 2 }} transition={{ type: "spring", stiffness: 400, damping: 17 }}>
            Oscar Alvarez
          </motion.h1>
        </div>

        <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
          <ul className="nav-list">
            <li>
              <button onClick={() => scrollToSection("hero")} className="nav-link">
                Inicio
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection("about")} className="nav-link">
                Sobre mí
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection("skills")} className="nav-link">
                Habilidades
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection("projects")} className="nav-link">
                Proyectos
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection("contact")} className="nav-link">
                Contacto
              </button>
            </li>
          </ul>
        </nav>

        <button className="menu-toggle" onClick={toggleMenu} aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú"} aria-expanded={isMenuOpen}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
};

export default Header;
